export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-regular-127ea449b06124c441cb32f9fa90e8eb.ttf";